<template>
  <o-view :has-white-background="true">
    <o-nav-bar title="Gent Dampoort" :has-back-button="true" />
    <o-map :is-large="false" :markers="markers" />
    <o-section>
      <o-key-value label="Adres" value="Dampoortstraat 1, Gent" />
      <o-key-value
        label="Locatie"
        value="Aan het rondpunt naast het station Gent-Dampoort vindt u de Cambiowagens links van de bankautomaten."
        :full-width="true"
      />
    </o-section>
    <o-section>
      <p class="u-strong">Openbaar vervoer</p>
      <o-key-value label="Lijnen" value="tram 2, bus 3, 12" />
      <o-key-value label="Haltes" value="Station Gent-Dampoort" />
    </o-section>
    <o-section>
      <o-key-value label="Wagenklasses" />
      <o-cambio-car-type label="S Mini" />
    </o-section>
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'
import OKeyValue from '@/components/base/OKeyValue.vue'
import OCambioCarType from '@/components/OCambioCarType.vue'
import OSection from '@/components/base/OSection.vue'
export default {
  name: 'CambioClassIngo',
  components: { OSection, OMap, OKeyValue, OCambioCarType },
  data: () => ({
    markers: [
      {
        coordinates: [3.715, 51.05],
        type: 'cambio'
      }
    ]
  })
}
</script>

<style lang="scss"></style>
